import CryptoAES from 'crypto-js/aes';
import CryptoENC from 'crypto-js/enc-utf8';

export function retornoHashValor (variavel = '') {
    const desencriptacao =  CryptoAES.decrypt(
        variavel,
        process.env.REACT_APP_0
    );

    return desencriptacao.toString(CryptoENC);
}